import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAcsParamtersInboxData = createAsyncThunk(
    "acs-parameters/inbox",
    async ({ user, pagination }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getMakerAcsParametersList;
                apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getCheckerAcsParametersList;
                apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddUpdateAcsParameterReview = createAsyncThunk(
    "acs-parameters/inbox/added-updated-review",
    async ({ user, body, update }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;
            const action = update ? 'edit' : 'add';

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addOrUpdateAcsParameterMakerReviewTasks;
                apiURL = base + endpointpath + action;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addOrUpdateAcsParameterCheckerReviewTasks;
                apiURL = base + endpointpath + action;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const acsParametersInboxSlice = createSlice({
    name: "acs-parameters-inbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // GET ACS PARAMETERS INBOX DATA
            .addCase(getAcsParamtersInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAcsParamtersInboxData.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = data || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getAcsParamtersInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD UPDATE PARAMETER REVIEW
            .addCase(postAddUpdateAcsParameterReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddUpdateAcsParameterReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateAcsParameterReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default acsParametersInboxSlice.reducer;